import { Alert } from '@mui/material'
import { t } from 'i18next'
import React, { memo } from 'react'
import { useAuth } from '../../hooks/useAuth'
import dayjs from 'dayjs'

function TrialAnalyticsBanner({ expirationDate,isTrialActif, isTrialEnded }: { expirationDate?:string,isTrialActif: boolean, isTrialEnded: boolean }) {
    const today_date = dayjs()

    if (isTrialEnded) {
        return (
            <Alert severity='info'>
                {t('demoModeExplanation')}
            </Alert>
        )
    }

    if (isTrialActif) {

        const diff = dayjs(expirationDate).diff(today_date, 'days')

        return (
            <Alert severity='info'>
                {t('trialModeExplanation', { days: diff })}
            </Alert>
        )
    }

    return <></>

}

export default memo(TrialAnalyticsBanner)